import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { string, arrayOf, object, func } from 'prop-types';
import ListingItem from 'components/filtered-listing/items/ListingItem';

export default class TileContainerTable extends React.Component {
    constructor(props) {
        super(props);

        this.rowHover = React.createRef();
        this.tableWrapper = React.createRef();

        this.handleRowMouseEvent = this.handleRowMouseEvent.bind(this);
    }

    handleRowMouseEvent(e) {
        switch (e.type) {
            case 'mouseenter':
            case 'focus':
                this.applyRowHover(e.currentTarget);
                break;
            case 'mouseleave':
            case 'blur':
                this.removeRowHover(e.currentTarget);
                break;
            default:
                break;
        }
    }

    applyRowHover(target) {
        const position = target.getBoundingClientRect();
        const wrapperPosition = this.tableWrapper.current.getBoundingClientRect();

        this.rowHover.current.classList.remove('hidden');
        this.rowHover.current.style.top = `${position.top - wrapperPosition.top}px`;
        this.rowHover.current.style.left = `${position.left - wrapperPosition.left}px`;
        this.rowHover.current.style.width = `${position.width}px`;
        this.rowHover.current.style.height = `${position.height}px`;
    }

    removeRowHover() {
        this.rowHover.current.classList.add('hidden');
    }

    render() {
        if (!this.props.items.length) {
            return null;
        }
        const { refType } = this.props;
        const isContractor = refType.toLowerCase() === 'contractor';

        return (
            <div className="fl-tile-container-wrapper" ref={this.tableWrapper}>
                <div className="fl-tile-container-row-hover hidden" ref={this.rowHover} />
                <ReactCSSTransitionGroup
                    component="table"
                    className="fl-tile-container"
                    transitionName="fade-in-out"
                    transitionAppear={true}
                    transitionAppearTimeout={200}
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={200}
                >
                    <tbody>
                        <tr className="c-content-tile">
                            <th className="guid">
                                Docket
                            </th>
                            <th className="date">
                                Date
                            </th>
                            <th className="job">
                                Job
                            </th>
                            {!isContractor && (
                                <th className="costcode">
                                    Cost Code
                                </th>
                            )}
                            <th className="equipment">
                                Equipment
                            </th>
                            <th className="material">
                                Material
                            </th>
                            {!isContractor && (
                                <th className="foreman">
                                    Foreman
                                </th>
                            )}
                            <th className="site">
                                Site
                            </th>
                            <th className="status">
                                Status
                            </th>
                            {!isContractor && (
                                <th className="file-link">
                                    &nbsp;
                                </th>
                            )}
                        </tr>
                        {this.props.items.map((item, index) => (
                            <ListingItem
                                /* eslint-disable react/no-array-index-key */
                                // @NOTE - ideally the key should be item.guid but this creates a jumpy effect with React transition group, so we will
                                //         keep using index for now until we find a better solution
                                key={index}
                                handleOpenModal={this.props.handleOpenModal}
                                item={item}
                                tileType={this.props.tileType}
                                handleMouseEvent={this.handleRowMouseEvent}
                                refType={refType}
                                /* eslint-enable react/no-array-index-key */
                            />
                        ))}
                    </tbody>
                </ReactCSSTransitionGroup>
            </div>
        );
    }
}

TileContainerTable.propTypes = {
    items: arrayOf(object).isRequired,
    tileType: string.isRequired,
    handleOpenModal: func.isRequired,
    refType: string
};

TileContainerTable.defaultProps = { refType: 'client' };
